// faqData.ts
export const faqData = [
  {
    id:1,
    question: "What is cybersecurity?",
    answer: "Cybersecurity refers to protecting your business systems, networks, and data from digital risks such as phishing, ransomware, malware, and data breaches."
  },
  { id:2,
    question: "Why is cybersecurity important for businesses today?",
    answer: "As businesses become more digital, cyber risks increase. A cyber incident can impact finances, operations, customer trust, and regulatory compliance. Being prepared helps protect business continuity."
  },
  { id:3,
    question: "What are the common cyber risks faced by Indian businesses?",
    answer: "Indian businesses commonly face phishing attacks, ransomware, data leaks, payment fraud, malware infections, and unauthorised access to systems."
  },
  { id:4,
    question: "Does cybersecurity apply only to large enterprises?",
    answer: "No. Startups and SMEs are equally vulnerable. In fact, smaller businesses are often targeted due to limited security controls and awareness."
  },
  { id:5,
    question: "What regulations govern cybersecurity in India?",
    answer: "Cybersecurity in India is governed by the Information Technology Act, CERT-In guidelines, and the Digital Personal Data Protection (DPDP) Act, 2023."
  },
  { id:6,
    question: "What is the DPDP Act, 2023?",
    answer: "The DPDP Act defines how personal data must be collected, stored, and protected. It also holds organisations accountable in case of data breaches or misuse."
  },
  { id:7,
    question: "What is CERT-In and why does it matter?",
    answer: "CERT-In is India’s national cyber incident response authority. Certain cyber incidents must be reported to CERT-In within prescribed timelines."
  },
  { id:8,
    question: "Are businesses required to report cyber incidents?",
    answer: "Yes. As per CERT-In guidelines, specific cyber incidents must be reported within 6 hours of detection."
  },
  { id:9,
    question: "What is a data breach?",
    answer: "A data breach occurs when sensitive business or customer data is accessed, disclosed, or stolen without authorization."
  },
  { id:10,
    question: "What is ransomware?",
    answer: "Ransomware is a cyber attack where access to data or systems is blocked until a ransom is paid."
  },
  { id:11,
    question: "How can businesses protect themselves from cyber risks?",
    answer: "A strong cybersecurity approach includes secure systems, regular backups, employee awareness, compliance readiness, and financial protection."
  },
  { id:12,
    question: "What is cyber insurance?",
    answer: "Cyber insurance helps businesses manage the financial impact of cyber incidents by covering costs related to data breaches, ransomware, legal liabilities, and business disruption."
  },
  { id:13,
    question: "What does cyber insurance typically cover?",
    answer: "Coverage may include incident response costs, legal expenses, regulatory support, business interruption losses, ransomware-related expenses, and third-party liabilities."
  },
  { id:14,
    question: "Is cyber insurance mandatory in India?",
    answer: "Cyber insurance is not mandatory, but it is strongly recommended for businesses handling customer data, digital payments, or online platforms."
  },
  { id:15,
    question: "Who should consider cyber insurance?",
    answer: "Any business that stores, processes, or transacts data digitally, including startups, SMEs, IT firms, fintechs, healthcare providers, and e-commerce companies."
  },
  { id:16,
    question: "How can Policybazaar for Business help?",
    answer: "Policybazaar for Business helps you assess cyber risks, compare cyber insurance solutions across insurers, and choose coverage aligned to your business needs."
  },
  { id:17,
    question: "What should a business do after a cyber incident?",
    answer: "Secure systems immediately, assess the impact, comply with reporting requirements, inform stakeholders, and initiate recovery with expert support."
  },
  { id:18,
    question: "How does cyber insurance support business continuity?",
    answer: "It provides financial and expert support during cyber incidents, helping businesses recover faster and minimise operational disruption."
  },
 
];
